import { IConsultantSuiviChangementHeuresSuppRequestModel } from "./core/_models"
import { Form, Formik, FormikHelpers } from "formik"
import { toast } from "react-toastify"
import * as Yup from "yup"
import { AxiosError } from "axios"
import { IConsultantModel, IHttpErrorResponseModel } from "@common-models/*"
import { CONST_HTTP_CUSTOM_CODE_FORM_VALIDATION_ERROR } from "@common-constants/*"
import MyAlert from "@common-utils/MyAlert"
import MySimpleSpinner from "@common-utils/MySimpleSpinner"
import React from "react"
import { consultantSuiviChangementHeuresSuppRequest } from "./core/_requests"
import MyDateDayMonthYearField from "@common-utils/fields/MyDateDayMonthYearField"
import MyInputField from "@common-utils/fields/MyInputField"
import moment from "moment"

const ConsultantSuiviChangementHeuresSupp = ({ consultants, onSubmitCallback = () => {}, annulerCallback = () => {} }: IPropsModel) => {
     // Form schema
     const schema = Yup.object().shape({
          date: Yup.string().required().label(`"Date de prise d'effet"`),
          heuresSuppJour: Yup.string().required().label(`"Heures supp. jour"`),
     })

     // Init values
     const initialValues: IConsultantSuiviChangementHeuresSuppRequestModel = {
          consultants: consultants.map(c => c.id as number),
     }

     // Handle submit
     function handleSubmit(values: IConsultantSuiviChangementHeuresSuppRequestModel, helpers: FormikHelpers<IConsultantSuiviChangementHeuresSuppRequestModel>) {
          helpers.setStatus(null)

          consultantSuiviChangementHeuresSuppRequest(values)
               .then(r => {
                    toast.success("Le changement d'heures supp. sera pris en compte à partir du " + moment(values.date).format("dddd D MMMM YYYY"), { autoClose: 5000 })
                    onSubmitCallback()
               })
               .catch((e: AxiosError) => {
                    const error: IHttpErrorResponseModel = e.response?.data

                    // Set form errors
                    if (error?.code === CONST_HTTP_CUSTOM_CODE_FORM_VALIDATION_ERROR && error?.errors) {
                         for (const key in error.errors) helpers.setFieldError(key, error.errors[key])
                    }

                    // Set form global status and notify user using a toast
                    helpers.setStatus(error?.detail)
                    toast.error(error?.detail, { autoClose: false })

                    // Stop submit loader
                    helpers.setSubmitting(false)
               })
     }

     return (
          <>
               <Formik initialValues={initialValues} validationSchema={schema} onSubmit={handleSubmit}>
                    {helpers => {
                         return (
                              <Form noValidate autoComplete="off">
                                   {helpers.status && (
                                        <MyAlert type={"danger"} classNames={"mb-4"}>
                                             {helpers.status}
                                        </MyAlert>
                                   )}

                                   {/* Date */}
                                   <div className="row mb-4">
                                        <label className={`col-lg-4 col-form-label fw-bold fs-6 required`}>Date de prise d'effet</label>

                                        <div className="col-lg-8">
                                             <MyDateDayMonthYearField
                                                  name={"date"}
                                                  value={helpers.values.date}
                                                  onChange={val => helpers.setFieldValue("date", val)}
                                                  isInvalid={!!helpers.errors.date}
                                                  placeholder={"Date de prise d'effet"}
                                                  autofocus
                                             />
                                             {helpers.errors.date && <div className={"text-danger"}>{helpers.errors.date}</div>}
                                        </div>
                                   </div>

                                   {/* Heures supp. jour */}
                                   <div className="row mb-4">
                                        <label className="col-lg-4 col-form-label fw-bold fs-6 required">Heures supp. jour</label>

                                        <div className="col-lg-8">
                                             <MyInputField
                                                  type={"number"}
                                                  inputMode={"numeric"}
                                                  name={"heuresSuppJour"}
                                                  value={helpers.values.heuresSuppJour}
                                                  isInvalid={!!helpers.errors.heuresSuppJour}
                                                  onChange={val => helpers.setFieldValue("heuresSuppJour", val)}
                                                  placeholder={"Heures supp. jour"}
                                             />
                                             {helpers.errors.heuresSuppJour && <div className={"text-danger"}>{helpers.errors.heuresSuppJour}</div>}
                                        </div>
                                   </div>

                                   {/* Submit button */}
                                   <div className={"d-flex justify-content-end"}>
                                        <button
                                             className={"btn btn-sm btn-outline btn-outline-primary d-inline-flex align-items-center me-2"}
                                             type={"button"}
                                             onClick={annulerCallback}
                                             disabled={helpers.isSubmitting}
                                        >
                                             Annuler
                                        </button>
                                        <button className={"btn btn-sm btn-primary d-inline-flex align-items-center"} type={"submit"} disabled={helpers.isSubmitting}>
                                             {!helpers.isSubmitting ? <>Valider</> : <MySimpleSpinner size={"sm"} />}
                                        </button>
                                   </div>
                              </Form>
                         )
                    }}
               </Formik>
          </>
     )
}

interface IPropsModel {
     consultants: IConsultantModel[]
     onSubmitCallback?: () => void
     annulerCallback?: () => void
}

export default ConsultantSuiviChangementHeuresSupp
